import React, { useMemo, Suspense } from "react";
import NoSsr from "@material-ui/core/NoSsr";
import { graphql } from "gatsby";
import * as R from "ramda";
import { Helmet } from "react-helmet";
import { StoryblokComponent } from "@sb-konzept/gatsby-source-storyblok";
import PageContext from "components/PageContext";
import PageLayout from "components/PageLayout";
import FullScreenLoader from "components/FullScreenLoader";
import {
  createStandortDescription,
  createStandortTitle
} from "../utils/standortDescriptions";

function DojoDantraeger(props) {
  const { data, pageContext } = props;

  const {
    page: {
      content: { body, layout }
    },
    siteInfo
  } = data;

  // Defensive check for missing siteInfo
  if (!siteInfo) {
    console.error(`Missing siteInfo for page: ${pageContext?.siteInfo}`);
    return (
      <PageLayout>
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h1>Seite nicht verfügbar</h1>
          <p>Die Standortinformationen konnten nicht geladen werden.</p>
        </div>
      </PageLayout>
    );
  }

  const {
    content: { location }
  } = siteInfo;

  const { header, footer } = useMemo(
    () =>
      R.applySpec({
        header: R.pathOr(null, [0, "content", "header", 0]),
        footer: R.pathOr(null, [0, "content", "footer", 0])
      })(layout),
    [layout]
  );

  return (
    <PageContext.Provider value={{ page: data.page }}>
      {header && <StoryblokComponent content={header} />}
      <PageLayout>
        <NoSsr>
          <Suspense fallback={<FullScreenLoader />}>
            <Helmet>
              <title>{createStandortTitle(location, "Dantraeger")}</title>
              <meta
                name="description"
                content={createStandortDescription(location, "Dantraeger")}
              />
            </Helmet>
            <StoryblokComponent content={siteInfo.content} />
            <StoryblokComponent content={data.page.content} />
          </Suspense>
        </NoSsr>
      </PageLayout>
      {footer && <StoryblokComponent content={footer} />}
    </PageContext.Provider>
  );
}

export default DojoDantraeger;

export const pageQuery = graphql`
  query($id: String!, $siteInfo: String!) {
    page: storyblokDojoDantraegerStory(id: { eq: $id }) {
      ...storyblokDojoDantraegerStory
    }
    siteInfo: storyblokDojoSiteInfoStory(full_slug: { eq: $siteInfo }) {
      ...storyblokDojoSiteInfoStory
    }
  }
`;